import React from "react";

const services = [
  {
    icon: "/images/icons/service-1.png",
    title: "Premium Fabrics",
    desc: "High-quality fabrics that last and feel premium.",
  },
  {
    icon: "/images/icons/service-2.png",
    title: "Customization",
    desc: "Tailor-made solutions to match your style.",
  },
  {
    icon: "/images/icons/service-3.png",
    title: "Expert Design",
    desc: "Creative designs from our experienced team.",
  },
  {
    icon: "/images/icons/service-5.png",
    title: "Bulk Order",
    desc: "Efficient handling of large orders with care.",
  },
];

const ServicesSection = () => {
  return (
    <section className="service-section pt-0 pt-lg-4">
      <div className="container">
        {/* Heading */}
        <div className="row">
          <div className="col-12 text-center">
            <h2 className="fw-bold display-5 text-dark">Why Choose Us</h2>
            <p className="text-dark lead">
              We bring quality, design, and trust to your home
            </p>
          </div>
        </div>
        {/* Services */}
        <div className="row g-4 justify-content-center">
          {services.map((service, idx) => (
            <div key={idx} className="col-lg-3 col-md-6 col-sm-6">
              <div className="service-block text-center p-4 border rounded shadow-sm h-100">
                <div className="icon mb-3">
                  <img
                    src={service.icon}
                    alt={service.title}
                    style={{ maxWidth: "70px" }}
                  />
                </div>
                <h5 className="fs-4 fw-bold mb-2 text-white">{service.title}</h5>
                <p className="text-light small">{service.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <style jsx>{`
        .service-block {
          position: relative;
          overflow: hidden;
          background: #02132f;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .service-block:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 25px rgba(0, 0, 0, 0.25);
        }

        /* Continuous shining animation */
        .service-block::before {
          content: "";
          position: absolute;
          top: 0;
          left: -150%;
          width: 50%;
          height: 100%;
          background: linear-gradient(
            120deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.2) 50%,
            rgba(255, 255, 255, 0) 100%
          );
          transform: skewX(-25deg);
          animation: shineMove 3s linear infinite;
        }

        @keyframes shineMove {
          0% {
            left: -150%;
          }
          100% {
            left: 150%;
          }
        }

        @media (max-width: 768px) {
          .service-block {
            margin-bottom: 20px;
          }
        }
      `}</style>
    </section>
  );
};

export default ServicesSection;
